import VehicleFault from './VehicleFault';

export default VehicleFault;
